<script>
import Posts from '../components/Posts'
import DefaultLayout from '../layouts/Default'

export default {
  name: 'Feed',
  components: {
    DefaultLayout,
    Posts,
  },
  computed: {
    authorized() { return !!this.$store.state.auth.token },
    posts() { return this.$store.getters['post/posts'] }, // Посты
    total() { return this.$store.state.post.total }, // N постов на чарте
    loading() { return this.$store.state.post.loading }, // N постов на чарте
    limit() { return this.$store.state.post.MAX_RECORDS },
    moreLimit() { return this.$store.state.post.LOAD_MORE_RECORDS },
  },
  watch: {
    authorized: {
      handler(isAuthorized, wasAuthorized) {
        if (isAuthorized && !wasAuthorized) { this.getPosts() }
      },
      immediate: true,
    },
  },
  created() {
    const { $store } = this
    $store.dispatch('post/getList')
    $store.dispatch('user/getList', { reload: true })
  },
  mounted() {
    this.setupScroll()
  },
  methods: {
    getPosts() {
      const { $store, loading, limit } = this
      if (loading) return
      $store.dispatch('post/getList', { limit })
    },
    loadMorePosts() {
      const { $store, loading, posts, moreLimit: limit, total } = this
      if (loading || !posts || posts.length >= total) return
      $store.dispatch('post/getList', { offset: posts.length, limit })
    },
    setupScroll() {
      const el = document.querySelector('.v-content')
      const onScroll = () => {
        const h = el.getBoundingClientRect().height
        const bodyRect = document.body.getBoundingClientRect()
        const scroll = bodyRect.height - bodyRect.y
        // console.warn(`${h} ${scroll}`)
        if ((h - scroll) <= (250)) {
          this.loadMorePosts()
        }
      }
      window.addEventListener('scroll', onScroll, false)
      this.$once('hook:beforeDestroy', () =>
        window.removeEventListener('scroll', onScroll, false))
    },
  },
}
</script>

<template>
  <DefaultLayout class="FeedView">
    <h1 class="mb-4 display-1">
      Лента событий
    </h1>
    <VSkeletonLoader
      :loading="loading && !posts"
      type="article@5"
    >
      <Posts />
    </VSkeletonLoader>
  </DefaultLayout>
</template>

<style lang="sass" scoped>
  .FeedView
    max-height: 100vh
</style>
